module.exports = __webpack_public_path__ + "static/media/hero-default-2x.fcd8ed16.webp";